import type { GameState } from '../game/state';
export const shouldPlayMusic=(state:GameState):boolean=>state==='PLAYING';
